module.exports = __webpack_public_path__ + "img/logo-petit-nature.760ec72c.jpg";